import { useEffect, useMemo, useState } from 'react'

import {
  getLocationAddress,
  isMatchedLocation,
  selectAllServiceLocations,
} from '@user/store/entityLocations'
import { LocationMenu, NoteCode } from '@user/components/Notes/typings'
import { getNoteCodes } from '@user/store/notes/api'
import { useAppDispatch } from '@user/store/hooks'
import { useSelector } from 'react-redux'

export function usePestPacNoteOptionsSelector() {
  const [noteCodes, setNoteCodes] = useState<NoteCode[]>([])
  const serviceLocations = useSelector(selectAllServiceLocations)
  const dispatch = useAppDispatch()

  const matchedLocations = useMemo(
    () => serviceLocations.filter(isMatchedLocation),
    [serviceLocations],
  )

  const serviceOptions: LocationMenu[] = useMemo(
    () =>
      matchedLocations?.map((l) => ({
        value: l.id.toString(),
        label: `${l.locationCode} - ${getLocationAddress(l)}`,
      })) || [],
    [matchedLocations],
  )

  useEffect(() => {
    const execute = async () => {
      try {
        const result = await dispatch(getNoteCodes())
        if (getNoteCodes.fulfilled.match(result)) {
          const { payload } = result
          setNoteCodes(payload?.items || [])
        }
      } catch (error) {
        setNoteCodes([])
      }
    }

    execute()
  }, [dispatch])

  return {
    matchedLocations: serviceLocations,
    serviceOptions,
    noteCodes,
  }
}
